import React, { useState, useEffect } from 'react';
import validate from 'validate.js';
import { Card, Button, TextField, Typography } from '@material-ui/core';
import { PROJECTS_ROUTE } from '../../../constants/routes';
import './Login.scss';
import { LOGIN } from './login.gql';
import { withRouter } from 'react-router-dom';
import { Mutation } from 'react-apollo';

function Login(props) {
  const { history, refetch } = props;

  const [loginError, setLoginError] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [formState, setFormState] = useState({
     isValid: false,
     values: {},
     touched: {},
     errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);
    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const handleSubmit = async (event, login) => {
    event.preventDefault();
    login().then(async ({ data, error }) => {
      setServerError(false);
      setLoginError(false);
      localStorage.setItem('token', data.login.token);
      await refetch();
      history.push(PROJECTS_ROUTE);
    }).catch(function(e) {
      if(JSON.stringify(e).includes("UNAUTHENTICATED")) {
        setServerError(false);
        setLoginError(true);
      } else {
        // ECONNREFUSED ERROR
        setServerError(true);
      }
    });
  };

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <Mutation mutation={LOGIN} variables={{ username: formState.values.username, password: formState.values.password }}>
      {(login, { data, loading, error }) => (
          <div className="login">
            <Card className="card-area">
              <Typography className="card-header" variant="h1">Anmelden</Typography>
              <Typography variant="caption">Bitte geben Sie Ihre Benutzerdaten an um sich anzumelden.</Typography>
              <div className="content-body">
                <form className="form" onSubmit={event => {handleSubmit(event, login)}}>
                  <TextField
                    className="text-field"
                    color="primary"
                    error={hasError('username')}
                    fullWidth
                    label="Benutzername"
                    name="username"
                    onChange={handleChange}
                    type="text"
                    value={formState.values.username}
                    variant="standard"
                  />
                  <TextField
                    className="text-field"
                    color="primary"
                    error={hasError('password')}
                    fullWidth
                    label="Passwort"
                    name="password"
                    onChange={handleChange}
                    type="password"
                    value={formState.values.password}
                    variant="standard"
                  />
                  {loginError && <Typography variant="body1" color="error">
                    Benutzername oder Passwort falsch.
                  </Typography>}
                  {serverError && <Typography variant="body1" color="error">
                    Server nicht erreichbar.
                  </Typography>}
                  <Button
                    className="login-button"
                    color="primary"
                    disabled={!formState.isValid}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Login
                  </Button>
                </form>
              </div>
            </Card>
            <div className="footer">
              <Typography variant="body1">
                <strong>ERZ Web-UI</strong>&nbsp;
              </Typography>
              <Typography variant="caption">&copy; Copyright 2019&nbsp;Green Way Systems GmbH</Typography>
            </div>
          </div>
      )}
    </Mutation>
  );
};

const schema = {
  username: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  }
};

export default withRouter(Login);
